import React, { useState } from 'react';
import './OrganizationRow.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logComponent from '../../common/logComponent';

export default function OrganizationRow({ showDetail, organization }) {
  const { name, status } = organization;
  const { isNew, type } = organization.uiData;

  if (logComponent('OrganizationRow')) { console.debug('OrganizationRow rendered'); }


  const handleButtonClick = () => {
    if (logComponent('OrganizationRow')) { console.debug('OrganizationRow handleButtonClick'); }
    showDetail(organization);
  }

  const getStatusIcon = () => {
    if (logComponent('OrganizationRow')) { console.debug('OrganizationRow getStatusIcon'); }

    let iconToUse = (status === 'rejected' ? 'rejected' : ( isNew ? 'new' : 'updated'));
    

    switch(iconToUse) {
      case 'rejected': 
        return (
          <div className="Organization-Row__rejected">
            <FontAwesomeIcon className="Organization-Row__rejected-icon" icon="times-circle" />
            <div className="Organization-Row__icon-text">Rejected</div>
          </div>);
      case 'new': 
        return (
          <div className="Organization-Row__new">
            <FontAwesomeIcon className="Organization-Row__new-icon" icon="certificate" />
            <div className="Organization-Row__icon-text">New</div>
          </div>);    
      case 'updated': 
        return (
          <div className="Organization-Row__updated">
            <FontAwesomeIcon className="Organization-Row__updated-icon" icon="sync-alt" />
            <div className="Organization-Row__icon-text">Updated</div>
          </div>);              
      default:
        return '';    
    }
  }


  return (
    <tr className="Organization-Row">
      <td className="Organization-Row__cell Organization-Row__name-cell">{name}</td>
      <td className="Organization-Row__cell Organization-Row__type-cell">{type}</td>
      <td className="Organization-Row__cell"> {getStatusIcon()} </td>
      <td className={'Organization-Row__cell' + (status === 'rejected' ? ' Organization-Row__cell--hidden' : '')}>
        <button
          className="Organization-Row__icon-btn"
          onClick={handleButtonClick}>
          <FontAwesomeIcon icon="ellipsis-h"></FontAwesomeIcon>
        </button>
      </td>
    </tr>
  );
}